<template>
    <div>
        <b-button  v-if="userData.name === 'Maciej Kryczka'" class="backButton" v-on:click="showLogs()" >WYŚWIETL LOGI</b-button>
        <div v-if="logButtons" class="logContainer">
            <div v-for="item in status" :key="item._id" class="logButton" v-on:click="showDetails(item)">{{item.date}}</div>
        </div>
        <div v-if="buttonClicked">
            <b-card>
                <p><span>Data:</span> {{chosenLog.date}}</p>
                <p><span>Autor:</span> {{chosenLog.author}}</p>
                <p><span>Grupa:</span> {{chosenLog.group}}</p>
                <p><span>Treść wiadomości:</span> {{chosenLog.message}}</p>
                <p><span>Numery:</span></p>
                <p v-for="item in chosenLog.numbersID" :key="Number(Object.values(item))">{{Number(Object.keys(item))}}</p>
                <b-button v-on:click="deleteLog(chosenLog._id)">Usuń log</b-button>
            </b-card>
        </div>
        <!-- <b-button  v-if="logButtons" class="backButton" v-on:click="delAllLogs()">Usuń wszystkie logi</b-button> -->
    </div>
</template>

<script>
import axios from 'axios';
import {bmPath} from '../../config';
export default {
    name: 'LogsList',
    props: ['userData'],
    methods: {
        showLogs() {
            console.log('pokaz Logi')
            axios
            .get(`${bmPath}logs`)
            .then(response => (
                    this.status = response.data
                ))
            .catch(e => (
                console.log(e)
            ))
            this.logButtons = !this.logButtons;
            this.buttonClicked = false;
        },
        showDetails(item){
            this.logButtons = false;
            this.buttonClicked = true;
            this.chosenLog = item;
        },
        async deleteLog(id){
            await axios
                .delete(`${bmPath}logs/${id}`)
                .then(r => console.log(r.status))
                .catch(e => console.log(e));
            console.log('log deleted')
        },
        async delAllLogs(){
            await axios
                .delete(`${bmPath}logs`)
                .then(r => console.log(r.status))
                .catch(e => console.log(e));
            console.log('all logs deleted')
        }
    },
    data: function(){
        return {
            status: '',
            logButtons: false,
            buttonClicked: false,
            chosenLog: {},
        }
    }
    
}
</script>

<style lang="scss" scoped>
    .backButton {
        height: 50px;
        width: 90%;
        font-size: 20px;
        background-color: darkslategray;
        border-radius: 10px;
        border: none;
        margin: 10px auto;
        &:hover{
            background-color: rgb(40, 110, 214);
        }
        &:focus{
            // background-color: blue;
            border: none;
            box-shadow: none;
        }
    }
    .logContainer {
        display: flex;
        flex-direction: column-reverse;
    }
    .logButton {
        cursor: pointer;
        padding: 10px;
        border: solid;
        border-width: 2px;
        border-radius: 5px;
        max-width: 200px;
        margin: 10px auto;
        background-color: darkslategray;
        color: white;
        &:hover{
            background-color: rgb(40, 110, 214);
        }
    }
</style>